<template>

  <text-field
    id="card-number-field"
    class="card_number-field"
    v-model="form[name]"
    :validation="$v"
    :validationMessage="textRequired"
    :label="textLabel"
    :rest="{
      placeholder: placeholder
        ? placeholderText || textLabel
        : null,
      autocomplete: 'cc-number',
      'data-bluesnap': 'encryptedCreditCard',
    }"
    type="tel"
    theme="variant-1"
    :tabindex="tabindex"
    :order="order"
    @input="input">
    <template #prefix>
      <img class='lazy' :data-src='iconSrc' />
    </template>
    <template #postfix>
      <img :src="`${$root.cdn_url}/assets/images/fa/fa-lock.svg`" width='13' height='15'>
    </template>
  </text-field>

</template>


<script>

  import globals from '../../../mixins/globals';
  import Cleave from 'cleave.js';


  export default {

    props: [
      'form',
      'name',
      'placeholderText',
      'placeholder',
      'tabindex',
      'order',
      '$v',
    ],


    mixins: [
      globals,
    ],


    data() {
      return {
        oldValue: this.form[this.name],
      };
    },


    mounted() {

      this.lazyload_update();

      js_deps.wait_for(() => {
        return !!document.querySelector('#card-number-field input');
      }, () => {
        var cleave = new Cleave('#card-number-field input', {
          creditCard: !document.querySelector('html[dir="rtl"]'),
          onCreditCardTypeChanged: function (type) {
              // update UI ...
          }
        });
      });
    },


    updated() {
      this.lazyload_update();
    },


    computed: {

      textLabel() {
        return this.$t('checkout.payment_form.card_number');
      },

      textRequired() {
        return this.$t('checkout.payment_form.card_number.required');
      },

      iconSrc(){
        return this.$root.paymentMethods && this.form.payment_method && this.$root.paymentMethods[this.form.payment_method]
          ? this.$root.paymentMethods[this.form.payment_method].logo
          : js_data.cdn_url + '/assets/images/cc-icons/iconcc.png';
      }
    },


    methods: {

      input() {
        let value = this.form[this.name] || '';

        if (!/^[0-9]{0,19}$/.test(value.replace(/\s/g, ''))) {
          value = this.oldValue;
        }

        this.$emit('setPaymentMethodByCardNumber', value);

        this.form[this.name] = value;
        this.oldValue = value;
      },

    },

  };

</script>


<style lang="scss" scoped>

  #card-number-field {

    :global(.prefix > img) {
      height: 22px;
      width: auto;
    }

    :global(input) {
      font-family: 'Pathway Gothic One', sans-serif !important;
      font-size: 19px !important
    }

  }

</style>
